import React, { useState } from 'react';

/* eslint-disable no-unused-vars */

interface TextAreaFieldProps {
  label?: any;
  name?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: any;
  rows?: number;
  fullWidth?: boolean;
  labelSize?: number;
  labelWidth?: number;
  disable?: boolean;
  error?: string;
  maxLength?: number;
}

export const TextAreaField = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  rows = 4,
  fullWidth,
  labelSize,
  labelWidth,
  disable,
  error,
  maxLength,
}: TextAreaFieldProps) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <label
      className={`flex flex-col relative text-[#4F5057] ${
        fullWidth ? 'w-full' : ''
      } ${labelSize ? `text-[${labelSize}px]` : 'text-[14px]'}
      ${labelWidth ? `font-[${labelWidth}]` : 'font-[400]'}`}
    >
      {label}
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disable}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        rows={rows}
        maxLength={maxLength}
        className={`placeholder-[#ABB4BF] text-[16px] rounded-[5px] px-[16px] py-[12px] resize-none
          border border-[#D5D9DF] focus:outline-none focus:border-[#4F5057]
          ${isFocused || !value ? 'bg-white' : 'bg-[#F4F4F4]'}`}
      />
      {maxLength && (
        <div className="text-right text-[12px] text-[#4f5057] mt-1">
          {value.length}/{maxLength}
        </div>
      )}
      {error && <div className="text-red-500">{error}</div>}
    </label>
  );
};
